import { useEffect, useState } from "react";
import Header from "../../Components/SDE24/Header";
import { useTranslation } from "react-i18next";
import * as api from '../../../api';
import Section from "../../Atoms/Section";
import CandidatureOldComponent from "../../Components/SDE24/Candidatures";
import { useNavigate } from "react-router";
import Spinner from "../../../Plateforme/Atoms/Spinner";

const Candidatures = (props) => {

    const [event, setEvent] = useState(null);
    const [participation, setParticipation] = useState(null);
    const navigate = useNavigate();

    const { i18n } = useTranslation('common');

    //get eid and uid from url, then get users participations, then get the right one and set it in state
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        const userIdFromParam = new URLSearchParams(window.location.search).get("uid");
        
        if (!eventIdFromParam || !userIdFromParam) {
            console.log("no event id or user id in url");
            return;
        }

        api.getEventById({ id: eventIdFromParam }).then((response) => {
            setEvent(response.data);
        }).catch((error) => {
            console.log(error);
        });

        api.getUserParticipations({userid: userIdFromParam}).then((resParticipations) => {
            const matchingParticipation = resParticipations.data.find(participation => participation.eventId === eventIdFromParam);
            if(matchingParticipation) {
                setParticipation(matchingParticipation);
            }
        })
    }, [])

    if (!event) {
        return <Spinner/>
    }

    return (
        <div>
            <Header overrideTitle={event._id === "663a220d253dde5f2058429b" ? "SPEED DATING DESIGN OBJET : mardi 04 juin" : ''} overrideSentence={"Pour vous inscrire, choisissez et priorisez les entreprises que vous souhaitez rencontrer."}/>
            {props.fullUser?.user ? <CandidatureOldComponent event={event} user={props.fullUser.user} allUserData={props.fullUser} participation={participation} onBack={() => navigate('/evenements/')}/> : <Spinner/>}
            {event.type === "sdo" ? <Section className="padding">{i18n.language === "fr" ? "Si vous rencontrez un problème lors de votre inscription, merci d'envoyer un email détaillant votre problème à l'adresse suivante : design@via.fr." : "If you encounter any issue during your registration, please send an email detailing your problem to the following address: design@via.fr."}</Section> : <Section className="padding">{i18n.language === "fr" ? "Si vous rencontrez un problème lors de votre inscription, merci d'envoyer un email détaillant votre problème à l'adresse suivante : boury@via.fr, nous reviendrons vers vous rapidement. Pour les urgences, contactez le +33144681814 (du lundi au vendredi - 10h/17h)." : "If you encounter any issue during your registration, please send an email detailing your problem to the following address: boury@via.fr, we will get back to you quickly. For emergencies, contact +33144681814 (Monday to Friday - 10am/5pm)."}</Section>}
        </div>
    )
}

export default Candidatures;